import React from "react";
import { PageHero, useSeo } from "../components/Shared";
import { COMPANY } from "../lib/site";

const H = ({ children }) => (
  <h2 className="mt-10 text-lg font-extrabold tracking-tight text-brand-black md:text-lg">{children}</h2>
);
const P = ({ children }) => <p className="mt-3 text-sm leading-relaxed text-brand-gray sm:text-base">{children}</p>;
const LI = ({ children }) => <li className="mt-2 text-sm leading-relaxed text-brand-gray sm:text-base">{children}</li>;

export default function Terms() {
  useSeo("Terms of Use | MJG Promotions", "Terms governing use of the MJG Promotions website at mjgpromotions.com.");
  return (
    <>
      <PageHero eyebrow="Legal" title="Terms of Use" intro="The terms that govern your use of this website." />
      <section className="bg-white py-16 sm:py-20" data-testid="terms-page">
        <div className="mx-auto max-w-3xl px-5">
          <p className="text-sm font-semibold text-brand-gray">Last updated: June 2026</p>
          <P>
            These Terms of Use ("Terms") govern your access to and use of {COMPANY.domain} (the "Site"), operated by
            {" "}{COMPANY.name} ("MJG," "we," "us"). By using the Site, you agree to these Terms. If you do not agree,
            please do not use the Site.
          </P>

          <H>Use of the Site</H>
          <P>
            The Site is provided for business informational purposes — to describe MJG's services and allow you to
            request consultations or quotes. You agree to use the Site lawfully and not to interfere with its
            operation, attempt unauthorized access, or submit false, misleading, or malicious content.
          </P>

          <H>Quotes & Inquiries</H>
          <P>
            Submitting a form on this Site is a request for information only. It does not create a contract, order, or
            commitment by either party. Pricing, availability, timelines, and service terms are confirmed only in a
            written quote or agreement issued by MJG.
          </P>

          <H>Intellectual Property</H>
          <P>
            All content on the Site — including text, graphics, logos, and page design — is owned by or licensed to
            {" "}{COMPANY.name} and is protected by applicable intellectual property laws. You may not reproduce,
            distribute, or create derivative works from Site content without our prior written permission, except for
            normal browser caching and personal, non-commercial reference.
          </P>
          <P>
            Trademarks, product names, and logos of third parties that appear on the Site belong to their respective
            owners and are shown for identification purposes only.
          </P>

          <H>Third-Party Links & Portals</H>
          <P>
            The Site links to external services, including client ordering portals hosted by third parties. Those
            services are governed by their own terms and privacy policies, and MJG is not responsible for their
            content or practices.
          </P>

          <H>Disclaimers</H>
          <P>
            The Site and its content are provided "as is" and "as available" without warranties of any kind, express
            or implied, including warranties of merchantability, fitness for a particular purpose, and
            non-infringement. We do not warrant that the Site will be uninterrupted, error-free, or free of harmful
            components.
          </P>

          <H>Limitation of Liability</H>
          <P>
            To the fullest extent permitted by law, {COMPANY.name} will not be liable for any indirect, incidental,
            special, consequential, or punitive damages arising out of or relating to your use of the Site. Nothing in
            these Terms limits liability that cannot be limited under applicable law.
          </P>

          <H>Indemnification</H>
          <P>
            You agree to indemnify and hold harmless {COMPANY.name} from claims arising out of your misuse of the Site
            or violation of these Terms.
          </P>

          <H>Governing Law</H>
          <P>
            These Terms are governed by the laws of the State of New Jersey, without regard to conflict-of-law rules.
            Any dispute relating to the Site will be brought in the state or federal courts located in New Jersey.
          </P>

          <H>Changes</H>
          <P>
            We may revise these Terms at any time by updating this page. Continued use of the Site after changes
            constitutes acceptance of the revised Terms.
          </P>

          <H>Contact</H>
          <P>
            Questions about these Terms:
          </P>
          <ul className="ml-5 list-disc">
            <LI>{COMPANY.name}, {COMPANY.address}</LI>
            <LI>Phone: {COMPANY.phone}</LI>
            <LI>Email: <a href={COMPANY.emailHref} className="font-semibold text-brand-red hover:underline">{COMPANY.email}</a></LI>
          </ul>
        </div>
      </section>
    </>
  );
}
